import React, {useState, useEffect, useCallback, useRef} from 'react'
import { useLocation, useHistory} from 'react-router-dom'
import SelectBoxV2 from '../modules/common/SelectBoxV2'
import RadioButton from '../modules/common/RadioButton'
import { APIs } from '../modules/apiClient'
import round_loading_bar from '../../resources/img/round_loading_bar.gif'
import fix_icon from '../../resources/img/fix_icon.svg';
import $ from 'jquery';
import LazyLoad from 'react-lazyload';
import TitleContentDialogV2 from '../modules/dialogs/TitleContentDialogV2';

/**
 * 상품자동진열 - 쇼핑몰 통계 페이지 (진열별 통계)
 */
let letCafe24CategoryNo = "";
let letCafe24CategoryList = [];
const titleContentOverwrite = {
    stepOneTitle: "상품덮어쓰기 선택시 변경전 주의사항",
    stepTwoTitle: "<br />상품덮어쓰기 선택시 두번째 주의사항",
    stepOneContent(src) {
        return "<img id='overwrite1' src='" + src + "' /> <br />" +
            "<br />알고리즘 설정대로<br />" +
            "상품 자동선정 수 만큼만 자동으로 분석해서<br />" +
            "<b style='white-space: nowrap'> 기존 상품을 덮어씌워서 선정수량만 노출됩니다.</b><br />" +
            "동의하시겠습니까?<br /><br />";
    },
    stepTwoContent(src) {
        return `<img id="overwrite2" src="${src}" style="margin-top:5px" alt="Overwrite" />
        <br />
        <br />
        덮어쓰기기능은<br />
        <b>일반상품 단독 사용시에만 설정하기를 권장합니다.</b><br />
        카페24구조상 덮어쓰기 기능을 사용하시면<br />
        추천.신상품 코너가 자동삭제됩니다.<br />
        그래도 적용하시겠습니까?<br />`
    },
}

const RpProductListStatisticsForPopup = (props) => {
    const isInitialized = useRef(false);

    const {
        iframePageId: clone_iframe_page_id,
        cafe24MainDisplayGroup: clone_cafe24_main_display_group,
        cafe24CategoryNo: clone_cafe24_category_no,
        cafe24CategoryDisplayGroup: clone_cafe24_category_display_group,
        cafe24CategoryDisplayType: clone_cafe24_category_display_type,
        subCategoryProductDisplay: clone_sub_category_product_display,
        categoryDepth: clone_category_depth,
        cafe24CategoryNoList: clone_cafe24_category_no_list,
        cafe24CategoryList: clone_cafe24_category_list,
      } = props;

    const location = useLocation()
    const history = useHistory()
    
    // 각 상태 초기화 (프롭스 값이 있으면 사용, 없으면 기본값)
    const [iframePageId, setIframePageId] = useState(clone_iframe_page_id || "robomd_cafe24_main_page");
    const [cafe24MainDisplayGroup, setcafe24MainDisplayGroup] = useState(clone_cafe24_main_display_group ?? null);
    const [cafe24CategoryNo, setCafe24CategoryNo] = useState(clone_cafe24_category_no || "");
    const [cafe24CategoryDisplayGroup, setCafe24CategoryDisplayGroup] = useState(clone_cafe24_category_display_group ?? 1);
    const [cafe24CategoryDisplayType, setSubCategoryProductDisplayType] = useState(clone_cafe24_category_display_type || clone_cafe24_category_display_group > 1 ? "1":"2");
    const [subCategoryProductDisplay, setSubCategoryProductDisplay] = useState(clone_sub_category_product_display || "F");
    const [categoryDepth, setCategoryDepth] = useState(clone_category_depth ?? 2);
    const [cafe24CategoryNoList, setCafe24CategoryNoList] = useState(clone_cafe24_category_no_list.length > 0 ? clone_cafe24_category_no_list : new Array(5).fill(""));
    const [cafe24CategoryList, setCafe24CategoryList] = useState(clone_cafe24_category_list || []);

    // 나머지 상태는 기존대로
    const [iframePageIdList, setIframePageIdList] = useState([]);
    const [mainCategoryList, setMainCategoryList] = useState([]);
    const [productList, setProductList] = useState([]);
    const [analysisStandardValue, setAnalysisStandardValue] = useState("4");
    const [showLoadingBar, setShowLoadingBar] = useState(true);
    const [highlightType, setHighlightType] = useState("");
    const [cafe24CategoryDisplayTypeList, setSubCategoryProductDisplayTypeList] = useState([
        { value: 1, title: "상품 덮어쓰기" },
        { value: 2, title: "상품 상단추가" },
    ]);
    const [titleContentDialogShowState, setTitleContentDialogShowState] = useState(false);
    const [titleContentDialogTitle, setTitleContentDialogTitle] = useState('');
    const [titleContentDialogContent, setTitleContentDialogContent] = useState('');
    const [titleContentDialogCheckBoxText, setTitleContentDialogCheckBoxText] = useState('');
    const [titleContentDialogButtonList, setTitleContentDialogButtonList] = useState([]);
    const [titleContentDialogCheckBoxChecked, setTitleContentDialogCheckBoxChecked] = useState(false);

    // 콜백 저장용 ref
    const callbackFuncRef = useRef();

    const highlightConnect = useRef();

    const eventItemAnalysisStandardList = [
        { value: "1/D", title: "최근 1일" },
        { value: "2/D", title: "최근 2일" },
        { value: "3/D", title: "최근 3일" },
        { value: "4/D", title: "최근 4일" },
        { value: "5/D", title: "최근 5일" },
        { value: 1, title: "최근 1주" },
        { value: 2, title: "최근 2주" },
        { value: 3, title: "최근 3주" },
        { value: 4, title: "최근 4주" },
    ];
    const cafe24CategoryDisplayGroupList = [{value:1, title:"일반 상품"},{value:2, title:"추천 상품"},{value:3, title:"신상품"}]

    useEffect(() => {
        console.log('[변화 감지] iframePageId:', iframePageId);
      }, [iframePageId]);
      
      useEffect(() => {
        console.log('[변화 감지] mainDisplayGroup:', cafe24MainDisplayGroup);
      }, [cafe24MainDisplayGroup]);
      
      useEffect(() => {
        console.log('[변화 감지] cafe24CategoryNo:', cafe24CategoryNo);
      }, [cafe24CategoryNo]);
      
      useEffect(() => {
        console.log('[변화 감지] cafe24CategoryDisplayGroup:', cafe24CategoryDisplayGroup);
      }, [cafe24CategoryDisplayGroup]);
      
      useEffect(() => {
        console.log('[변화 감지] cafe24CategoryDisplayType:', cafe24CategoryDisplayType);
      }, [cafe24CategoryDisplayType]);
      
      useEffect(() => {
        console.log('[변화 감지] subCategoryProductDisplay:', subCategoryProductDisplay);
      }, [subCategoryProductDisplay]);
      
      useEffect(() => {
        console.log('[변화 감지] categoryDepth:', categoryDepth);
      }, [categoryDepth]);
      
      useEffect(() => {
        console.log('[변화 감지] cafe24CategoryNoList:', cafe24CategoryNoList);
      }, [cafe24CategoryNoList]);
      
      useEffect(() => {
        console.log('[변화 감지] cafe24CategoryList:', cafe24CategoryList);
      }, [cafe24CategoryList]);
      

    /** 무료 체험 기간 조회 : 무료체험 기간이 끝났다면 위에 링크를 쳐서 들어오는 것을 막는다 */
    const loadFreeDatePeriod = async () => {
        await APIs.rp.getCheckingFreeDatePeriod()
            .then(res => {
                if (res.data != null && res.data != '') {
                    // console.log("this.props.history.action", this.props.history.action);
                    if(res.data["is_finish"] != 0){
                        alert("사용 기간이 종료 되었습니다");
                        // this.props.history.replace({ pathname: `/shop/rp/event/list` })
                        if (history.action !== 'POP') {
                            history.goBack();
                        } else {
                            history.replace({ pathname: `/shop/rp/main` })
                        }
                    }
                }
            })
            .catch(error => {});
    }

    /** Iframe 설정값 불러오기 */
    const loadUpperCodeListIframeList = async () => {
        try {
            const res = await APIs.rp.getSettingsByUpperCode("16000");
            if (res.data != null && res.data !== '') {
                let iframe_page_id_list = res.data;
                if (sessionStorage.getItem("user_id") !== "test_rp" && sessionStorage.getItem("user_id") !== "marketb") {
                    iframe_page_id_list = iframe_page_id_list.filter(item => item.code_cd !== "16002" && item.val2 === "cafe24");
                }
                setIframePageIdList(iframe_page_id_list);
            }
        } catch (err) {
            console.error("Error loading iframe list: ", err);
        }
    };
    
    /** 왼쪽 영역 값 불러오기 (진열 위치) */
    const loadUpperCodeListCategoryList = async () => {
        try {
            if (mainCategoryList != null && mainCategoryList.length > 0) {
                setcafe24MainDisplayGroup(mainCategoryList[0]["display_group"]);
                return;
            }
            const res = await APIs.rp.getMainCategory();
            if (res.data.code == 200) {
                setMainCategoryList(res.data["main_category_list"]);
                if (!clone_cafe24_main_display_group) {
                    setcafe24MainDisplayGroup(res.data["main_category_list"][0]["display_group"]);
                }
            }
        } catch (err) {
            console.error("Error loading category list: ", err);
        }
    };
    
    /** 카테고리 진열 - 상품분류 불러오기 */
    const loadCafe24Category = async (parentCategory, depth) => {
        console.log("###### parentCategory", parentCategory)
        console.log("###### depth", depth)
        try {
            const res = await APIs.rp.getCafe24Category(depth, parentCategory);
            if (res.data.code == "200") {
                const productCategoryList = res.data["product_category_list"];
                const newCafe24CategoryNoList = [...cafe24CategoryNoList];
                if (depth == 1) {
                    newCafe24CategoryNoList[depth-1] = productCategoryList[0]["category_no"];
                } 
                for (let idx = depth == 1 ? 2 : (depth-1); idx <= 4; idx++) {
                    newCafe24CategoryNoList[idx] = "";
                }
                setCafe24CategoryNoList(newCafe24CategoryNoList);
                if (depth >= 2) {
                    if (productCategoryList.length > 0) {
                        productCategoryList.splice(0,0,{category_name_no:"전체상품", category_name : "전체상품", category_no : "전체상품"});
                    }
                } else {
                    setCafe24CategoryNo(productCategoryList[0]["category_no"]);
                }
                const newCafe24CategoryList = [...letCafe24CategoryList];
                newCafe24CategoryList[depth - 1] = productCategoryList;
                for (let idx = depth; idx <= 5; idx++) {
                    newCafe24CategoryList[idx] = [];
                }
                letCafe24CategoryList = newCafe24CategoryList;
                setCafe24CategoryList(newCafe24CategoryList);
            }
        } catch (err) {
            console.error("Error loading cafe24 category: ", err);
        }
    };
    

    /** 메인진열 - 카페24에서 메인진열을 불러오는 함수 */
    const loadCafe24MainProductList = useCallback(async () => {
        if (!cafe24MainDisplayGroup) return;
        setShowLoadingBar(true);
        try {
            const res = await APIs.rp.getCafe24MainProductList(cafe24MainDisplayGroup);
            if (res.data.code == "200") {
                setProductList(res.data.main_product_list.map((obj, idx) =>
                    obj.fixed_sort ? { ...obj, sequence_no: idx + 1 } : obj
                ));
            }
        } catch (err) {
            console.log(err);
        }
        setShowLoadingBar(false);
    }, [cafe24MainDisplayGroup]);
    
    /** 카테고리 진열 - 카페24에서 카테고리 진열을 불러오는 함수 */
    const loadCafe24CategoryProductList = async () => {
        setShowLoadingBar(true);
        try {
          const res = await APIs.rp.getCafe24CategoryProductList(
            cafe24CategoryNo,
            cafe24CategoryDisplayGroup
          );
          setProductList(res.data["category_product_list"]);
          setShowLoadingBar(false);
        } catch (e) {
            console.error('카페24 카테고리 상품 불러오기 실패', e);
        }
    };

    /** 통계수 분석기간 */
    const reloadProductByAnalysisStandard = useCallback(async () => {
        const product_nos = productList.map(f=> f.product_no)
        try {
            const res = await APIs.rp.getProductsByAnalysisStandard(product_nos, analysisStandardValue, 0, product_nos.length)
            const list = res.data.list;
                let copy_product_list = JSON.parse(JSON.stringify(productList));
                for (let idx1 in productList) {
                    for (let idx2 in list) {
                        if (productList[idx1].product_no == list[idx2].product_no) {
                            /* analysis_standard_value에 의해 조회된 값으로 대체 */
                            copy_product_list[idx1].hit_cnt = list[idx2].hit_cnt
                            copy_product_list[idx1].cart_cnt = list[idx2].cart_cnt
                            copy_product_list[idx1].wish_cnt = list[idx2].wish_cnt
                            copy_product_list[idx1].review_point = list[idx2].review_point
                            copy_product_list[idx1].review_cnt = list[idx2].review_cnt
                            copy_product_list[idx1].order_cnt = list[idx2].order_cnt
                            copy_product_list[idx1].order_price = list[idx2].order_price
                        }
                    }
                }

            setProductList(copy_product_list)
        } catch (error) {
            console.log(error)
        }
    }, [analysisStandardValue]);
    

    /** 메인진열, 카테고리진열 확인 */
    const getCurrentPath = () => {
        return location.pathname.split('/')[location.pathname.split('/').length - 1]
    }

    /** 메인 테이블이 로드 될떄 드래그 스크롤을 위한 max_height 설정 */
    const onLoadMainTable = () => {
        let window_height = $(window).height();
        // window 높이에 따라서 메인테이블의 max-height가 달라지도록 적용(드래그 스크롤을 위한 작업)
        $("#list_admin_main_board").css({"max-height":window_height-330});
        $("#main_table_tbody").css({"max-height":window_height-400});
    }

    /** 카페24 카테고리진열 카테고리 변경 */
    const onChangeCafe24Category = (name, value, id) => {
        const depth = Number(id.split('_')[2]) + 2;
        setCategoryDepth(depth);

        let newCafe24CategoryNoList = [...cafe24CategoryNoList];
        let newCafe24CategoryList = [...cafe24CategoryList];

        if (["전체상품", ""].includes(value)) {
            if (depth > 2) {
                for (let idx = depth - 2; idx <= 3; idx++) {
                    newCafe24CategoryNoList[idx] = "";
                }

                for (let idx = depth - 1; idx <= 3; idx++) {
                    newCafe24CategoryList[idx] = [];
                }

                setCafe24CategoryNo(newCafe24CategoryNoList[depth - 3]);
            } else {
                setCafe24CategoryNo("");

                for (let idx = depth - 2; idx <= 3; idx++) {
                    newCafe24CategoryNoList[idx] = "";
                }

                for (let idx = depth - 1; idx <= 3; idx++) {
                    newCafe24CategoryList[idx] = [];
                }
            }
        } else {
            // 현재 depth 값 반영
            newCafe24CategoryNoList[depth - 2] = value;

            // 현재 depth 아래 하위 카테고리 초기화
            for (let idx = depth - 1; idx <= 3; idx++) {
                newCafe24CategoryNoList[idx] = "";
                newCafe24CategoryList[idx] = [];
            }

            setCafe24CategoryNo(value);
        }

        setCafe24CategoryNoList(newCafe24CategoryNoList);
        setCafe24CategoryList(newCafe24CategoryList);
    };

    /** 카페24 카테고리 분류 설정 검사 : 단일 카테고리 조회 */
    const checkCafe24CategorySetting = async () => {
        await APIs.rp.getCheckingCafe24CategorySettingSingle(cafe24CategoryNo)
            .then((res) => {
                if(res.data.code == "200"){
                    if (res.data.product_category) {
                        setSubCategoryProductDisplay(res.data.product_category.sub_category_product_display)
                    }
                } 
            })
            .catch((error) => {
                setSubCategoryProductDisplay("F")
                // alert("카테고리 분류 조회에 실패하였습니다.");
            });
    }

    useEffect(() => {
        if (!isInitialized.current) return;
        // clone을 통해 초기 세팅된 경우 불필요한 호출 방지
        // if (
        //     clone_cafe24_category_no_list?.length > 0 &&
        //     clone_cafe24_category_list?.length > 0
        // ) return;

        if ((letCafe24CategoryNo == cafe24CategoryNo)) return;

        if (categoryDepth !== 5 && !["", "전체상품"].includes(cafe24CategoryNo)) {
            loadCafe24Category(cafe24CategoryNo, categoryDepth);
        }
        letCafe24CategoryNo = cafe24CategoryNo;
    }, [cafe24CategoryNo, cafe24CategoryNoList, categoryDepth]);
    
    
    /** 메인진열 <-> 카테고리 진열 페이지 이동 */
    const reDirection = (to) => {
        window.location.href = `/shop/rp/event/product/statistics/${to}`;
    }

    // useEffect(() => {
    //     if (props.location && props.location.state && props.location.state.highlightType) {
    //       setHighlightType(props.location.state.highlightType);
    //     }
      
    //     const fetchData = async () => {
    //       try {
    //         await loadFreeDatePeriod();
    //         await loadUpperCodeListIframeList();
      
    //         if (iframePageId === "robomd_cafe24_main_page") {
    //           await loadUpperCodeListCategoryList();
    //         } else {
    //           // 프롭스로 받은 계층 카테고리 리스트 사용
    //           if (clone_cafe24_category_list && clone_cafe24_category_list.length > 0) {
    //             letCafe24CategoryList = clone_cafe24_category_list;
    //             setCafe24CategoryList(clone_cafe24_category_list);
    //           } else {
    //             await loadCafe24Category(1, 1);
    //           }
      
    //           // 카테고리 선택 상태 초기화
    //           if (clone_cafe24_category_no_list && clone_cafe24_category_no_list.length > 0) {
    //             setCafe24CategoryNoList(clone_cafe24_category_no_list);
    //             const lastIndex = clone_cafe24_category_no_list.findLastIndex(v => v);
    //             setCafe24CategoryNo(clone_cafe24_category_no_list[lastIndex]);
    //             setCategoryDepth(lastIndex + 2);
    //           }
    //         }
    //       } catch (error) {
    //         console.error("Error in fetchData: ", error);
    //       }
    //     };
      
    //     fetchData();
    // }, []);

    useEffect(() => {
        if (props.location && props.location.state?.highlightType) {
          setHighlightType(props.location.state.highlightType);
        }
      
        const fetchData = async () => {
          try {
            // await loadFreeDatePeriod();
            await loadUpperCodeListIframeList();
      
            if (iframePageId === "robomd_cafe24_main_page") {
              await loadUpperCodeListCategoryList();
            } else {
              // clone_값 기반 초기 세팅은 useState에서만 하고 여기선 API 호출만
              if (!clone_cafe24_category_list || clone_cafe24_category_list.length === 0) {
                await loadCafe24Category(1, 1);
              } else {

              }
            }

            isInitialized.current = true;
            if (cafe24CategoryNoList[categoryDepth-2]) {
                await loadCafe24Category(cafe24CategoryNoList[categoryDepth-2], categoryDepth);
            } else {
                await loadCafe24Category(1, 1);
            }
          } catch (error) {
            console.error("Error in fetchData: ", error);
          }
        };
      
        fetchData();
    }, []);

    useEffect(() => {
        if (cafe24MainDisplayGroup) loadCafe24MainProductList()
    }, [cafe24MainDisplayGroup, loadCafe24MainProductList]);
    
    useEffect(() => {
        if (analysisStandardValue) reloadProductByAnalysisStandard()
    }, [analysisStandardValue]);

    useEffect(() => {
        if (cafe24CategoryDisplayGroup && cafe24CategoryNo) {
            if (cafe24CategoryDisplayGroup > 1) {
                setSubCategoryProductDisplayType("1");
            }
            checkCafe24CategorySetting();
            loadCafe24CategoryProductList();
        }
    }, [cafe24CategoryNo, cafe24CategoryDisplayGroup])

    useEffect(() => {
        if (!isInitialized.current) return;

        if (typeof props.onChangeMainGroupOrCategory === 'function' && props.onChangeMainGroupOrCategory) {
            const selectedDisplayNameGroup = mainCategoryList.find(
                item => item.display_group === cafe24MainDisplayGroup
              )?.group_name || "";

              const selectedCategoryNames = cafe24CategoryNoList.map((selectedNo, depth) => {
                const listAtDepth = cafe24CategoryList[depth];
                if (!listAtDepth || !selectedNo || selectedNo === "전체상품") return null;
              
                const matched = listAtDepth.find(item => item.category_no === selectedNo);
                return matched ? matched.category_name : null;
              }).filter(Boolean); // ← null 제거  

              const selectedLastCategoryName = selectedCategoryNames[selectedCategoryNames.length - 1];

            props.onChangeMainGroupOrCategory(
                iframePageId,
                cafe24MainDisplayGroup,
                cafe24CategoryNo,
                cafe24CategoryDisplayGroup,
                productList.length,
                cafe24CategoryDisplayType,
                subCategoryProductDisplay,
                categoryDepth,
                cafe24CategoryNoList,
                cafe24CategoryList,
                selectedDisplayNameGroup,
                selectedLastCategoryName,
            );
          }
    }, [iframePageId, 
        cafe24MainDisplayGroup, 
        cafe24CategoryNo, 
        cafe24CategoryDisplayGroup, 
        cafe24CategoryDisplayType, 
        subCategoryProductDisplay, 
        categoryDepth
    ])

    useEffect(() => {
        if (!isInitialized.current) return;

        try {
            if (iframePageId === "robomd_cafe24_main_page") {
                // 메인 진열 설정 시: 카테고리 초기화 & 메인 불러오기
                setCafe24CategoryNo("");
                setCafe24CategoryDisplayGroup(1);
                loadUpperCodeListCategoryList();
            } else {
                // 카테고리 진열 설정 시: 메인 초기화
                setcafe24MainDisplayGroup("");
    
                // clone으로 내려온 카테고리 리스트가 없을 때만 호출
                // if (!clone_cafe24_category_list || clone_cafe24_category_list.length === 0) {
                    loadCafe24Category(1, 1);
                // }
            }
        } catch (error) {
            console.error("Error in Change iframePageId fetchData: ", error);
        }
    }, [iframePageId]);

    /** 
     * 카페24 카테고리 진열 타입 변경 
     * 1: 덮어쓰기
     * 2: 유지 및 상단추가
     * */
    const onChangeCategoryRollingType = (e) => {
        setSubCategoryProductDisplayType(e.target.value);

        /** 덮어쓰기일 경우 경고 다이얼로그 출력 */
        if(e.target.value === "1") titleContentDialogOverwrite()
    }

    /** 덮어쓰기 경고 TitleContent Dialog */
    const titleContentDialogOverwrite = (onComplete = function() {}) => {
        if (localStorage.getItem("ignore_popup") === "Y") {
            onComplete(true)
            return
        }
        titleContentDialogForm(
            titleContentOverwrite.stepOneTitle,
            titleContentOverwrite.stepOneContent("/img/rollingProduct/guide_overwrite_1.svg"),
            {
                title: "확인",
                type: "1",
                event_method: () => {
                    setTitleContentDialogShowState(false);
                    setSubCategoryProductDisplayType("1");
                    onComplete(true)
                }
            },
            {
                title: "돌아가기",
                type: "0",
                event_method: () => {
                    setTitleContentDialogShowState(false);
                    setSubCategoryProductDisplayType("2");
                    onComplete(false); // 콜백 호출
                }
            },
            () => {},
            "다시보지 않기"
        )
    }

    /** 제목 내용 다이얼로그 */
    const titleContentDialogForm = (
        title_content_dialog_title = '',
        title_content_dialog_content = '',
        title_content_dialog_ok = {
          title: '확인',
          type: '1',
          event_method: () => setTitleContentDialogShowState(false),
        },
        title_content_dialog_cancel = {
          title: '아니요',
          type: '0',
          event_method: () => setTitleContentDialogShowState(false),
        },
        callbackFunc = () => {},
        title_content_dialog_check_box_text = ''
      ) => {
        callbackFuncRef.current = callbackFunc;
        setTitleContentDialogTitle(title_content_dialog_title);
        setTitleContentDialogContent(title_content_dialog_content);
        setTitleContentDialogCheckBoxText(title_content_dialog_check_box_text);
        setTitleContentDialogButtonList([
          { ...title_content_dialog_ok },
          { ...title_content_dialog_cancel },
        ]);
        setTitleContentDialogShowState(true);
    };

    useEffect(() => {
        if (titleContentDialogShowState && callbackFuncRef.current) {
            callbackFuncRef.current();
            callbackFuncRef.current = null;
        }
    }, [titleContentDialogShowState]);

    const onChangeTitleContentCheckBox = (e) => {
        const checked = e.target.checked;
        setTitleContentDialogCheckBoxChecked(checked);
        localStorage.setItem("ignore_popup", checked ? "Y" : "N");
    };

    return (
        <>
            {/* <div id='common-page-wrapper'> */}
                <div id="list_wrap" class="style_guide_v2 rp_setting_page">
                    <section class="list_admin_wrap">
                        <div class="list_admin_side_menu">
                            <div class="list_admin_side_menu_wrap">
                                <div className="list_admin_side_row_3 list_expand_wrap" ref={highlightConnect} style={{height:"auto", overflow:"visible", marginTop:"0px"}}>
                                    <div class="list_admin_side_title_1 list_admin_side_design_expand list_expand cafe24_list_expand" id="install_list_expand" style={{height:"auto", overflow:"visible"}}>
                                        <h3 class="text_16">위치 설정</h3>
                                    </div>
                                    <div class="list_admin_side_row_3_1 list_expand_1">
                                        <div class="list_admin_side_row_3_1c" style={{marginTop : "0px"}}>
                                            <h3 class="text_small">
                                                진열 위치
                                            </h3>
                                                <div class="select_list_position_disabled">
                                                    <SelectBoxV2 
                                                        id={"selectListPosition"}
                                                        width="100%"
                                                        height="36px"
                                                        padding="14px 36px 14px 16px"
                                                        list= {iframePageIdList}
                                                        optionTexttName = "val1"
                                                        optionValuetName = "code_name"
                                                        selectedValue = {iframePageId}
                                                        onClickOption = {(t, v, i) => setIframePageId(v)}
                                                    />
                                                </div>
                                            
                                            {/* 메인 진열 카테고리 */}
                                            {iframePageId === "robomd_cafe24_main_page"
                                                ? 
                                                <div style={{marginTop: "5px"}}>
                                                    <SelectBoxV2
                                                        id={"cafe24_main_select_list"}
                                                        tabIndex={0}
                                                        width="100%"
                                                        height="36px"
                                                        padding="14px 36px 14px 16px"
                                                        list= {mainCategoryList}
                                                        optionTexttName = "display_name_group"
                                                        optionValuetName = "display_group"
                                                        selectedValue = {cafe24MainDisplayGroup}
                                                        onClickOption={(name, value) => setcafe24MainDisplayGroup(value)}
                                                    />
                                                </div>
                                                : <></>
                                            }
                                            {/* 카페24 카테고리 진열 상품분류 */}
                                            {iframePageId === "robomd_cafe24_category_page"
                                                ?<>
                                                <h3 class="text_small list_admin_side_design_title">
                                                    상품분류
                                                </h3>
                                                <div class="list_select_margin" style={{width:"100%"}}>
                                                    {/** 카테고리 대분류 */}
                                                    <div class="list_category_select_box">
                                                        {<SelectBoxV2
                                                            id={"cafe24_category_0"}
                                                            tabIndex={0}
                                                            width="100%"
                                                            height="36px"
                                                            padding="14px 36px 14px 16px"
                                                            list= {cafe24CategoryList[0]}
                                                            optionTexttName = "category_name_no"
                                                            optionValuetName = "category_no"
                                                            selectedValue = {cafe24CategoryNoList[0] == "" ? "전체상품" : cafe24CategoryNoList[0]}
                                                            onClickOption={(name, value, id) => onChangeCafe24Category(name, value, id)}/>
                                                        }
                                                    </div>
                                                    {
                                                        cafe24CategoryList[1] != null && cafe24CategoryList[1].length > 0 
                                                        ?
                                                        <div class="list_category_select_box list_category_select_box_1">
                                                            {<SelectBoxV2
                                                                id={"cafe24_category_1"}
                                                                tabIndex={0}
                                                                width="100%"
                                                                height="36px"
                                                                padding="14px 36px 14px 16px"
                                                                list= {cafe24CategoryList[1]}
                                                                optionTexttName = "category_name_no"
                                                                optionValuetName = "category_no"
                                                                selectedValue = {cafe24CategoryNoList[1] == "" ? "전체상품" : cafe24CategoryNoList[1]}
                                                                onClickOption={(name, value, id) => onChangeCafe24Category(name, value, id)}/>
                                                            }
                                                        </div>
                                                        :   ""
                                                    }
                                                    {
                                                        cafe24CategoryList[2] != null && cafe24CategoryList[2].length > 0 
                                                        ?<div class="list_category_select_box list_category_select_box_1">
                                                            {<SelectBoxV2
                                                                id={"cafe24_category_2"}
                                                                tabIndex={0}
                                                                width="100%"
                                                                height="36px"
                                                                padding="14px 36px 14px 16px"
                                                                list= {cafe24CategoryList[2]}
                                                                optionTexttName = "category_name_no"
                                                                optionValuetName = "category_no"
                                                                selectedValue = {cafe24CategoryNoList[2] == "" ? "전체상품" : cafe24CategoryNoList[2]}
                                                                onClickOption={(name, value, id) => onChangeCafe24Category(name, value, id)}/>
                                                            }
                                                        </div>
                                                        : ""
                                                    }
                                                    {
                                                        cafe24CategoryList[3] != null && cafe24CategoryList[3].length > 0 
                                                        ? <div class="list_category_select_box list_category_select_box_1">
                                                            {<SelectBoxV2
                                                                id={"cafe24_category_3"}
                                                                tabIndex={0}
                                                                width="100%"
                                                                height="36px"
                                                                padding="14px 36px 14px 16px"
                                                                list= {cafe24CategoryList[3]}
                                                                optionTexttName = "category_name_no"
                                                                optionValuetName = "category_no"
                                                                selectedValue = {cafe24CategoryNoList[3] == "" ? "전체상품" : cafe24CategoryNoList[3]}
                                                                onClickOption={(name, value, id) => onChangeCafe24Category(name, value, id)}/>
                                                            }
                                                        </div>
                                                        : ""
                                                    }
                                                    {/* 카테고리 진열 상세 상품분류 */}
                                                    <h3 class="text_small list_admin_side_design_title">
                                                    <div style={{whiteSpace:"nowrap"}}>
                                                            상세 상품분류
                                                        </div>
                                                    </h3>
                                                    <div class="list_admin_side_row_3_1c_radio">
                                                        {
                                                            cafe24CategoryDisplayGroupList.map((obj, idx) => (
                                                                <RadioButton
                                                                    id={"cafe24_category_display_group_"+obj.value}
                                                                    name={"category_display_group"}
                                                                    value={obj.value}
                                                                    text={obj.title}
                                                                    checked={cafe24CategoryDisplayGroup==obj.value}
                                                                    onChangeCheck={(e) => setCafe24CategoryDisplayGroup(e.target.value)}/>
                                                            ))
                                                        }
                                                    </div>
                                                    
                                                </div>

                                                <h3 class="text_small list_admin_side_design_title">
                                                    <div style={{whiteSpace:"nowrap"}}>
                                                        상품 상세분류 진열방식
                                                    </div>
                                                </h3>
                                                <div class="list_admin_side_row_3_1c_radio">
                                                    {cafe24CategoryDisplayTypeList.map((obj, idx) => (
                                                        <RadioButton
                                                            id={"cafe24_category_display_type"+obj.value}
                                                            name={"category_manage_product_type"}
                                                            value={obj.value}
                                                            text={obj.title}
                                                            checked={cafe24CategoryDisplayType==obj.value}
                                                            disabled={cafe24CategoryDisplayGroup != "1"}
                                                            onChangeCheck={(e) => onChangeCategoryRollingType(e)}
                                                        />
                                                    ))}
                                                </div>
                                            </>
                                            :""}
                                        </div>
                                    </div>
                                </div>
                                {
                                    iframePageId == "robomd_cafe24_category_page" && subCategoryProductDisplay == "T"
                                    ? <div className='text_14 list_expand_wrap' style={{whiteSpace: "break-spaces"}}>
                                        <div class="list_admin_side_title_1 list_admin_side_design_expand list_expand cafe24_list_expand" id="install_list_expand" style={{height:"auto", overflow:"visible"}}>
                                            <h3 class="text_16">주의사항</h3>
                                        </div>
                                        <div className='list_expand_1'>
                                            <h3 class="text_small">하위 분류 상품이 진열되도록 설정되어 있습니다.</h3>
                                            <br/>
                                            카페24 관리자에서 상품 분류의 '하위 분류 상품 진열'을 '진열함'으로 설정하면, 하위 분류의 상품도 함께 노출되어요.
                                            <br/>
                                            <b style={{fontWeight: 500}}>이때 쇼핑몰에서 실제 노출되는 진열 순서가 다를 수 있어요.</b>
                                            <br/>
                                            <br/>
                                            설정한 진열 순서와 동일하게 쇼핑몰에서 상품이 진열되게 하려면 아래와 같이 상품 분류 설정에서 '하위 분류 상품 진열'을 <b style={{fontWeight: 500}}>'진열 안함'</b>으로 설정해야 해요.
                                            <br/>
                                            <div className='flexBox m-l-5'><span>•</span><div style={{flex:1, marginLeft:"7px"}}><a href="https://eclogin.cafe24.com/Shop/?onnode=1&menu=2136&mode=pro" target='_blank'>[카페24 관리자] 상품 &gt; 상품 관리 &gt; 상품 분류 관리</a> 에서 설정하려는 분류명을 눌러 주세요.</div></div>
                                            <div className='flexBox m-l-5'><span>•</span><div style={{flex:1, marginLeft:"7px"}}>'하위 분류 상품 진열' 항목 값을 '진열 안함'으로 선택하고 맨 아래쪽의 '확인' 버튼을 눌러 주세요.</div></div>
                                        </div>
                                    </div>
                                    : ""
                                }
                            </div>
                        </div>
                        <div class="list_admin_main_menu">
                            <div class="list_admin_main_menu_wrap">
                                {/* <div class="list_admin_main_menu_row_1">
                                    <div class="list_admin_main_menu_row_1_left">
                                        <div className="list_admin_main_menu_row_1_left_sync">
                                            <h2 class="text_16">통계 보기 &nbsp;</h2>
                                            <div style={{color: "#878B90"}}>총 <span style={{color: "#00ACB2"}}>{productList.length}</span>개 &nbsp;&nbsp;</div>
                                        </div>
                                    </div>
                                    <div class="list_admin_main_menu_row_1_right">
                                                                                        
                                    </div>
                                </div> */}
                                {/** 상품 목록 테이블 */}
                                <div class="list_admin_main_board">
                                    {/** 테이블 상단 상호작용 */}
                                    {/* <div class="list_main_board_row_1" style={getCurrentPath() === "category" ? {marginBottom: "10px", overflow: "visible", flexWrap:"wrap"} : {overflow: "visible", flexWrap:"wrap"}}>
                                        <div id={getCurrentPath() == "category" ? "eventItemAnalysisStandardAreaForCategoryPage" : "eventItemAnalysisStandardArea"}>
                                            통계수 분석기간
                                            <div style={{flex: 1, marginLeft:"10px"}}>
                                                <SelectBoxV2
                                                    style={{width:"100%"}}
                                                    id={"eventItemAnalysisStandard"}
                                                    tabIndex={0}
                                                    width="100%"
                                                    height="36px"
                                                    padding="14px 36px 14px 16px"
                                                    list= {eventItemAnalysisStandardList}
                                                    optionTexttName = "title"
                                                    optionValuetName = "value"
                                                    selectedValue = {analysisStandardValue}
                                                    onClickOption={(name, value, id) => setAnalysisStandardValue(value)}
                                                />
                                            </div>
                                        </div>
                                    </div> */}
                                    {/** 상품 리스트 */}
                                    <div className={"list_main_board_table_wrap"}>
                                        <table className={"list_main_board_table rp_list_main_table"}
                                            onLoad={e => onLoadMainTable()}>
                                            <thead>
                                                <tr>
                                                    <td class="list_main_td input_table_idx">순서</td>
                                                    <td class="list_main_td table_image">사진</td>
                                                    <td class="list_main_td product_name">상품명</td>
                                                    {/* <td class="list_main_td reg_date">상품등록일</td>
                                                    <td class="list_main_td hit_cnt">조회수</td>
                                                    <td class="list_main_td cart_cnt">장바구니수</td>
                                                    <td class="list_main_td price">판매가</td>
                                                    <td class="list_main_td pc_discount_price">할인가</td>
                                                    <td class="list_main_td order_cnt">판매수</td>
                                                    <td class="list_main_td order_price">판매액</td>
                                                    <td class="list_main_td review_cnt">리뷰수</td>
                                                    <td class="list_main_td review_point">리뷰 평점</td>
                                                    <td class="list_main_td quantity">재고수</td> */}
                                                </tr>
                                            </thead>   
                                            {!showLoadingBar ? (
                                                <tbody id="main_table_tbody">
                                                    {productList.map((value, index) => (
                                                        <LazyLoad 
                                                        offset="300"
                                                        once="true"
                                                        scrollContainer="#main_table_tbody"
                                                        throttle={100}
                                                        placeholder={
                                                            <tr
                                                                style={{
                                                                    height: "600 !important",
                                                                    overflowY: 'scroll !important',
                                                                    overflowX: 'hidden !important',
                                                                }}
                                                                key={value.product_no}
                                                                tabIndex={-1}
                                                            >
                                                                <td style={{height:"60px"}}></td>
                                                            </tr>
                                                        }
                                                        style={{ width: '100%' }}>
                                                            <tr
                                                                style={{
                                                                    height: "600 !important",
                                                                    overflowY: 'scroll !important',
                                                                    overflowX: 'hidden !important',
                                                                }}
                                                                key={value.product_no}
                                                                tabIndex={-1}
                                                            >
                                                                <td className={"input_table_idx"}>
                                                                    {index + 1}
                                                                    {   
                                                                        value.fixed_sort
                                                                        ? 
                                                                            <img 
                                                                            alt='fixed_sort'
                                                                            src={fix_icon} 
                                                                            style={{cursor:"default"}}
                                                                            />
                                                                        : null
                                                                    }
                                                                </td>
                                                                <td className={"table_image"}>
                                                                    <img src={value.image_url} alt={value.product_name} />
                                                                </td>
                                                                <td className={"product_name"}>{value.product_name}</td>
                                                                {/* <td className={"reg_date"}>{value.created_date}</td>
                                                                <td className={"hit_cnt"}>{value.hit_cnt}</td>
                                                                <td className={"cart_cnt"}>{value.cart_cnt}</td>
                                                                <td className={"price"}>{value.price}</td>
                                                                <td className={"pc_discount_price"}>{value.pc_discount_price}</td>
                                                                <td className={"order_cnt"}>{value.order_cnt}</td>
                                                                <td className={"order_price"}>{value.order_price}</td>
                                                                <td className={"review_cnt"}>{value.review_cnt}</td>
                                                                <td className={"review_point"}>{value.review_point}</td>
                                                                <td className={"quantity"}>{value.quantity}</td> */}
                                                            </tr>
                                                        </LazyLoad>
                                                    ))}
                                                </tbody>
                                            ) : (
                                                <tbody style={{position: "relative", height:"200px"}}>
                                                    <div style={{width: $(".list_main_board_table_wrap").width(), height:"200px", display:"flex", justifyContent:"center"}}>
                                                        <img src={round_loading_bar} style={{width:"200px"}}></img>
                                                    </div>
                                                </tbody>
                                            )}
                                        </table>        
                                    </div> 
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                {/* 오른쪽 영역 초기화 다이얼로그*/
					(titleContentDialogShowState === true)
					? <TitleContentDialogV2
                    title={titleContentDialogTitle}
                    content={titleContentDialogContent}
                    button_list={titleContentDialogButtonList}
                    check_box_text={titleContentDialogCheckBoxText}
                    check_box_checked={titleContentDialogCheckBoxChecked}  
                    onChangeCheckBox={onChangeTitleContentCheckBox}        
                    popup_close={() => setTitleContentDialogShowState(false)}
                  />
					: ''
				}
            {/* </div> */}
        </>
    )
}

export default RpProductListStatisticsForPopup